import hook_Blue from "../Image/hook_Blue.jpg";
import hook_BlueSkyblueWhite from "../Image/hook_BlueSkyblueWhite.jpg";
import hook_BlueSkyblueWhite_ from "../Image/hook_BlueSkyblueWhite_.jpg";
import hook_BlueWhite from "../Image/hook_BlueWhite.jpg";
import hook_GreenWhite from "../Image/hook_GreenWhite.jpg";
import hook_OrangeYellowWhite from "../Image/hook_OrangeYellowWhite.jpg";
import hook_OrangeYellowWhite_ from "../Image/hook_OrangeYellowWhite_.jpg";
import hook_PinkRed from "../Image/hook_PinkRed.jpg";
import hook_PinkRed_ from "../Image/hook_PinkRed_.jpg";
import hook_Red from "../Image/hook_Red.jpg";
import hook_RedOrangeYellow from "../Image/hook_RedOrangeYellow.jpg";
import hook_RedOrangeYellow_ from "../Image/hook_RedOrangeYellow_.jpg";
import hook_VioletRedPink from "../Image/hook_VioletRedPink.jpg";
import hook_VioletRedPink_ from "../Image/hook_VioletRedPink_.jpg";
import stud_Blue from "../Image/stud_Blue.jpg";
import stud_Blue_ from "../Image/stud_Blue_.jpg";
import stud_BlueWhite from "../Image/stud_BlueWhite.jpg";
import stud_BlueWhite_ from "../Image/stud_BlueWhite_.jpg";
import stud_Green from "../Image/stud_Green.jpg";
import stud_Green_ from "../Image/stud_Green_.jpg";
import stud_Orange from "../Image/stud_Orange.jpg";
import stud_Orange_ from "../Image/stud_Orange_.jpg";
import stud_OrangeGreenYellow from "../Image/stud_OrangeGreenYellow.jpg";
import stud_OrangeGreenYellow_ from "../Image/stud_OrangeGreenYellow_.jpg";
import stud_RedWhite from "../Image/stud_RedWhite.jpg";
import stud_RedWhite_ from "../Image/stud_RedWhite_.jpg";
import stud_VioletPinkWhite from "../Image/stud_VioletPinkWhite.jpg";
import stud_VioletPinkWhite_ from "../Image/stud_VioletPinkWhite_.jpg";
import shell from "../Image/shell.jpg";
import shell_ from "../Image/shell2.jpg";

export const EarringsData = [
  // {
  //     img: hook_Blue,
  //     title: 'hook_blue',
  //     modal: ''
  // },
  {
    img: hook_BlueSkyblueWhite,
    title: "Blue Skyblue White",
    modal: hook_BlueSkyblueWhite_,
  },
  // {
  //     img: hook_BlueWhite,
  //     title: 'hook_blue-white',
  // },
  // {
  //     img: hook_GreenWhite,
  //     title: 'hook_green-white',
  // },
  {
    img: hook_OrangeYellowWhite,
    title: "Orange Yellow White",
    modal: hook_OrangeYellowWhite_,
  },
  {
    img: hook_PinkRed,
    title: "Pink Red",
    modal: hook_PinkRed_,
  },
  // {
  //     img: hook_Red,
  //     title: 'hook_Red',
  // },
  {
    img: hook_RedOrangeYellow,
    title: "Red Orange Yellow",
    modal: hook_RedOrangeYellow_,
  },
  {
    img: hook_VioletRedPink,
    title: "Violet Red Pink",
    modal: hook_VioletRedPink_,
  },
  {
    img: stud_Blue,
    title: "Blue",
    modal: stud_Blue_,
  },
  {
    img: stud_BlueWhite,
    title: "Blue White",
    modal: stud_BlueWhite_,
  },
  {
    img: stud_Green,
    title: "Green",
    modal: stud_Green_,
  },
  {
    img: stud_Orange,
    title: "Orange",
    modal: stud_Orange_,
  },
  {
    img: stud_OrangeGreenYellow,
    title: "Orange Green Yellow",
    modal: stud_OrangeGreenYellow_,
  },
  {
    img: stud_RedWhite,
    title: "Red White",
    modal: stud_RedWhite_,
  },
  {
    img: stud_VioletPinkWhite,
    title: "Violet Pink White",
    modal: stud_VioletPinkWhite_,
  },
  {
    img: shell,
    title: "Shell (@Ishigaki Island)",
    modal: shell_,
  },
];
